import httpService from "./httpService";

export default {
  getToken(vbAttachmentId) {
    return httpService.get("vbAttachmentToken/getToken", {
      params: { vbAttachmentId: vbAttachmentId }
    });
  },

  getTokenForViewVbTlt(vbAttachmentId) {
    return httpService.get("vbAttachmentToken/getTokenForViewVbTlt", {
      params: { vbAttachmentId: vbAttachmentId }
    });
  },

  getTokenForConfigLD(vbAttachmentId) {
    return httpService.get("vbAttachmentToken/getTokenForConfigLD", {
      params: { vbAttachmentId: vbAttachmentId }
    });
  },

  getTokenImage(attachmentMetaId) {
    return httpService.get("vbAttachmentToken/getTokenImage", {
      params: { attachmentMetaId: attachmentMetaId }
    });
  },

  getTokenDocRelation(docRelationId) {
    return httpService.get("vbAttachmentToken/getTokenDocRelation", {
      params: { docRelationId: docRelationId }
    });
  },

  getTokenDocRelationForConfigLD(docRelationId) {
    return httpService.get("vbAttachmentToken/getTokenDocRelationForConfigLD", {
      params: { docRelationId: docRelationId }
    });
  },

  getTokenForReferenceOutgoingAttachment(vbAttachmentId) {
    return httpService.get(
      "vbAttachmentToken/getTokenForReferenceOutgoingAttachment",
      { params: { vbAttachmentId: vbAttachmentId } }
    );
  },

  getTokenForReferenceOutgoingAttachmentForConfigLD(vbAttachmentId) {
    return httpService.get(
      "vbAttachmentToken/getTokenForReferenceOutgoingAttachmentForConfigLD",
      { params: { vbAttachmentId: vbAttachmentId } }
    );
  },

  downloadOriginalOutgoingDocForVTAsBase64(docId) {
    return httpService.get(
      "vbAttachmentToken/downloadOriginalOutgoingDocForVTAsBase64",
      { params: { docId: docId } }
    );
  },

  downloadVbAttachmentForVTAsBase64(vbAttachmentId) {
    return httpService.get(
      "vbAttachmentToken/downloadVbAttachmentForVTAsBase64",
      { params: { vbAttachmentId: vbAttachmentId } }
    );
  },

  downloadVbAttachmentAsBase64(docId) {
    return httpService.get(
      "vbAttachmentToken/downloadVbAttachmentAsBase64",
      { params: { docId: docId } }
    );
  },

  downloadRelationDocForVTAsBase64(relationDocId) {
    return httpService.get(
      "vbAttachmentToken/downloadRelationDocForVTAsBase64",
      { params: { relationDocId: relationDocId } }
    );
  },

  getTokenForDocRelateWithTask(taskId, docId) {
    return httpService.get("vbAttachmentToken/getTokenForDocRelateWithTask", {
      params: { taskId: taskId, docId: docId }
    });
  },

  getTokenForReferenceOutgoingDoc(docId) {
    return httpService.get(
      "vbAttachmentToken/getTokenForReferenceOutgoingDoc",
      { params: { docId: docId } }
    );
  },

  getTokenForOutgoingDoc(docId) {
    return httpService.get("vbAttachmentToken/getTokenForOutgoingDoc", {
      params: { docId: docId }
    });
  },

  getTokenForOutgoingDocVbLK(docId, objectType) {
    return httpService.get("vbAttachmentToken/getTokenForOutgoingDocVbLK", {
      params: { docId: docId, objectType: objectType }
    });
  },

  getTokenForOutgoingDocLanhDaoEdit(docId) {
    return httpService.get("vbAttachmentToken/getTokenForOutgoingDocLanhDaoEdit", {
      params: { docId: docId }
    });
  },


  getTokenForOutgoingDocForConfigLD(docId) {
    return httpService.get("vbAttachmentToken/getTokenForOutgoingDocForConfigLD", {
      params: { docId: docId }
    });
  },

  getTokenByDocIdAndObjectTypeForConfigLD(docId, objectType) {
    return httpService.get("vbAttachmentToken/getTokenByDocIdAndObjectTypeForConfigLD", {
      params: { docId: docId, objectType: objectType }
    });
  },

  getTokenForOutgoingDocWithToken(docId, objectType) {
    let params = { objectType: objectType, docId: docId };
    return httpService.get(
      "vbAttachmentToken/getTokenForOutgoingDocWithToken",
      { params: params }
    );
  },

  getTokenForIncomingDoc(docId) {
    return httpService.get("vbAttachmentToken/getTokenForIncomingDoc", {
      params: { docId: docId }
    });
  },

  getTokenAttachmentComment(vbAttachmentId) {
    return httpService.get("vbAttachmentToken/getTokenAttachmentComment", {
      params: { vbAttachmentId: vbAttachmentId }
    });
  },

  getTokenForShareLibrary(vbAttachmentId) {
    return httpService.get("vbAttachmentToken/getTokenForShareLibrary", {
      params: { vbAttachmentId: vbAttachmentId }
    });
  },

  getTokenForHcCaseCalendarAttachment(hcCaseCalendarId, vbAttachmentId) {
    return httpService.get(
      "vbAttachmentToken/getTokenForHcCaseCalendarAttachment",
      {
        params: {
          hcCaseCalendarId: hcCaseCalendarId,
          vbAttachmentId: vbAttachmentId
        }
      }
    );
  },

  getTokenForHcCommandsDocRelation(
    objectId,
    objectType,
    referenceObjectType,
    referenceObjectId
  ) {
    return httpService.get(
      "vbAttachmentToken/getTokenForHcCommandsDocRelation",
      {
        params: {
          objectId: objectId,
          objectType: objectType,
          referenceObjectType: referenceObjectType,
          referenceObjectId: referenceObjectId
        }
      }
    );
  },

  getTokenForHcCaseFlightFile(
    hcCaseFlightId,
    hcCaseFlightFileId,
    vbAttachmentId
  ) {
    return httpService.get("vbAttachmentToken/getTokenForHcCaseFlightFile", {
      params: {
        hcCaseFlightId: hcCaseFlightId,
        hcCaseFlightFileId: hcCaseFlightFileId,
        vbAttachmentId: vbAttachmentId
      }
    });
  },

  getTokenForTaskAttachment(tkTaskId, attachmentId) {
    return httpService.get("vbAttachmentToken/getTokenForTaskAttachment", {
      params: {
        tkTaskId: tkTaskId,
        attachmentId: attachmentId
      }
    });
  },

  getToken4DownloadOutgoingDocForVT(docId) {
    return httpService.get(
      "vbAttachmentToken/getToken4DownloadOutgoingDocForVT",
      {
        params: { docId }
      }
    );
  },

  getToken4DownloadOutgoingDocForVTLanhDaoEdit(docId) {
    return httpService.get(
      "vbAttachmentToken/getToken4DownloadOutgoingDocForVTLanhDaoEdit",
      {
        params: { docId }
      }
    );
  },

  getToken4DownloadOutgoingDocForTokenBanCoYeuCaDauVaChuKy(docId, vbAttachmentId) {
    return httpService.get(
      "vbAttachmentToken/getToken4DownloadOutgoingDocForTokenBanCoYeuCaDauVaChuKy",
      {
        params: {docId: docId, vbAttachmentId: vbAttachmentId}
      }
    );
  },

  getTokenForBlockedRole(vbAttachmentId, blockedUserId) {
    return httpService.get("vbAttachmentToken/getTokenForBlockedRole", {
      params: {
        vbAttachmentId: vbAttachmentId,
        blockedUserId: blockedUserId
      }
    });
  },

  getTokenForReferenceOutgoingAttachmentForBlockedRole(vbAttachmentId, blockedUserId) {
    return httpService.get(
      "vbAttachmentToken/getTokenForReferenceOutgoingAttachmentForBlockedRole", {
        params: {
          vbAttachmentId: vbAttachmentId,
          blockedUserId: blockedUserId
        }
      }
    );
  },

  getTokenForReferenceOutgoingDocForBlockedRole(docId, blockedUserId) {
    return httpService.get(
      "vbAttachmentToken/getTokenForReferenceOutgoingDocForBlockedRole",
      {
        params: {
          docId: docId,
          blockedUserId: blockedUserId
        }
      }
    );
  },

  getTokenForOutgoingDocForBlockedRole(docId, blockedUserId) {
    return httpService.get("vbAttachmentToken/getTokenForOutgoingDocForBlockedRole", {
      params: {
        docId: docId,
        blockedUserId: blockedUserId
      }
    });
  },

  getTokenForOutgoingDocWithTokenForBlockedRole(docId, objectType, blockedUserId) {
    let params = { objectType: objectType, docId: docId, blockedUserId: blockedUserId };
    return httpService.get(
      "vbAttachmentToken/getTokenForOutgoingDocWithTokenForBlockedRole",
      { params: params }
    );
  },

  getTokenOutgoingAttachment(docId, objectType) {
    let params = { objectType: objectType, docId: docId };
    return httpService.get(
      "vbAttachmentToken/getTokenOutgoingAttachment",
      { params: params }
    );
  },
};



// WEBPACK FOOTER //
// ./src/services/vbAttachmentTokenService.js